import { Erfahrungslevel } from '@/domain/mitarbeiter/features/anlageassistent/utils/constants/erfahrungslevel';
import { Mitarbeiter_Erfahrungslevel } from '@/gql/graphql';

export function mapErfahrung(
  erfahrungslevel: Erfahrungslevel | null,
): Mitarbeiter_Erfahrungslevel | null {
  if (!erfahrungslevel) return null;
  switch (erfahrungslevel) {
    case 'keineBewertung':
      return Mitarbeiter_Erfahrungslevel.Keinebewertung;
    case 'Anfaenger':
      return Mitarbeiter_Erfahrungslevel.Anfaenger;
    case 'Fortgeschrittener':
      return Mitarbeiter_Erfahrungslevel.Fortgeschrittener;
    case 'AlterHase':
      return Mitarbeiter_Erfahrungslevel.Alterhase;

    default:
      erfahrungslevel satisfies never;
      throw new Error(`Unsupported value: ${erfahrungslevel}`);
  }
}
